<template>
  <div>
    <div class="title">如何查找想要的商品？</div>
    <div class="content-info">
      <p
        class="txt1"
      >在首页/全部菜品界面的最上方空白处，输入所需商品名称查找。若未找到您所需的商品，可以在“我的”界面点击“提交新品需求”进行记录填写，我们会根据商户需求量进行采购售卖。</p>
      <ul>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/c734627b7246317277ad44870637941f.png" />
        </li>
        <li>
          <img src="https://img-oss.yunshanmeicai.com/cfile/f2360ab2c4f30dcfb32c79128ffdabb8.png" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
